import { useCallback } from "react";

import groupBy from "lodash/groupBy";
import { useMutation } from "react-query";
import { getLanContent } from "utils";

import { masterDataEthnicityListService } from "./services";

export const useEthnicityListByIds = () => {
  const { mutateAsync: getList } = useMutation({
    mutationKey: "masterDataEthnicityListService",
    mutationFn: masterDataEthnicityListService,
  });

  const getListByIds = useCallback(
    async (ids: number[]) => {
      try {
        if (!ids?.length) return {};

        const data = await getList({ ids });
        const dataTransform = data?.data?.items?.map((item) => ({
          id: item.id,
          name: getLanContent(item, "name"),
        }));
        return groupBy(dataTransform, "id") || [];
      } catch {
        return {};
      }
    },
    [getList]
  );

  return {
    getListByIds,
  };
};
